<template>
  <el-form-item :prop="isHandsel ? '' : 'handselList2'" class="handsel" :label="label">
    <div class="handsel-title">
      <div>商品名称</div>
      <div>售价</div>
      <div>{{ isHandsel ? "赠送次数" : "购买次数" }}</div>
      <div v-if="!isHandsel">每次平均价格</div>
      <div>操作</div>
    </div>

    <div class="handsel-list">
      <template :key="item" v-for="item in handselList">
        <div v-if="item.paraIdList.length > 0" class="handsel-item">
          <div class="name" v-if="item.serveId">{{ item.serveName }}</div>
          <div class="name">¥{{ item.paraIdList[0].price }}</div>
          <div class="name" v-if="item.goodName">{{ item.goodName }}</div>
          <div :class="{ isHandsel: isHandsel }" class="format-list">
            <template :key="ele" v-for="ele in item.paraIdList">
              <div class="format-item">
                <template v-if="category == 'serve'">
                  <div v-if="currentCardKind != '4'">
                    <el-input v-model="ele.Qty">
                      <template #suffix>| 次</template>
                    </el-input>
                  </div>
                  <div v-if="currentCardKind == '4'">
                    <el-input disabled placeholder="不限次数" />
                  </div>
                </template>

                <template v-else>
                  <div>
                    <el-input v-model="ele.Qty">
                      <template #suffix>| 次</template>
                    </el-input>
                  </div>
                </template>
                <div v-if="!isHandsel">
                  <template v-if="ele.averagePrice">
                    ¥ {{ ele.averagePrice.toFixed(2) }}
                  </template>
                  <template v-else> - </template>
                  <!-- <el-input readonly :v-model="ele.salePrice">
                    <template #suffix>| 元</template>
                  </el-input> -->
                </div>
                <div>
                  <el-button
                    v-if="item.serveId"
                    @click="handleHandelRmoveClick(item.serveId, ele.paraId, 'serve')"
                    size="small"
                    plain
                  >
                    删除</el-button
                  >
                  <el-button
                    v-if="item.goodId"
                    @click="handleHandelRmoveClick(item.goodId, ele.paraId, 'goods')"
                    size="small"
                    plain
                    >删除
                  </el-button>
                </div>
              </div>
            </template>
          </div>
        </div>
      </template>
    </div>
  </el-form-item>
</template>

<script lang="js">
import emitter from '@/utils/eventbus'
import { emit } from 'process'
import { defineComponent, reactive, ref, onUnmounted } from 'vue'

export default defineComponent({
  props: {
    label: {
      type: String,
      default: ""
    },
    handselList: {
      type: Array,
      default() {
        return []
      }
    },
    category: {
      type: String,
      default: 'serve'
    },
    isHandsel: {
      type: Boolean,
      default: false
    }
  },
  components: {

  },
  emits: ['handleSiteHandselClick'],
  setup(props, { emit }) {

    const handleSiteHandselClick = () => {
      emit('handleSiteHandselClick')
    }

    const handleHandelRmoveClick = (id, paraId, type) => {
      if (props.category == 'serve') {
        emitter.emit('addCardServeFormServeRmove', { serveId: id, paraId: paraId })
      } else {
        if (type == 'serve') {
          emitter.emit('addCardServeFormHandselServeRmove', { serveId: id, paraId: paraId })
        } else {
          emitter.emit('addCardServeFormHandselGoodsRmove', { goodId: id, paraId: paraId })
        }

      }
    }


    const currentCardKind = ref('')
    emitter.on('changeAddCardCardKind', kindId => {
      currentCardKind.value = kindId
    })

    onUnmounted(() => {
      emitter.off('changeAddCardCardKind')
    })

    const tips = ref('只读')

    return {
      tips,
      handleSiteHandselClick,
      handleHandelRmoveClick,
      currentCardKind
    }

  }
})
</script>

<style scoped lang="less">
.handsel {
  .handsel-title {
    display: flex;
    max-width: 806px;

    & > div {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .handsel-list {
    max-width: 806px;

    .handsel-item {
      display: flex;
      align-items: center;
      border-bottom: 1px solid var(--borderColor);
      padding: 4px 10px;

      .name {
        flex: 1;
        font-size: 12px;
        text-align: center;
      }

      .isHandsel {
        flex: 2 !important;
      }

      .format-list {
        flex: 3;

        .format-item {
          display: flex;
          justify-content: space-around;
          margin: 8px 0;

          &:deep(.el-input) {
            max-width: 140px;
          }

          & > div {
            flex: 1;
            display: flex;
            justify-content: center;
          }
        }
      }
    }
  }

  .handsel-title {
    color: rgba(80, 80, 80, 1);
    background-color: rgba(239, 239, 239, 1);
    font-size: 12px;
  }
}
</style>
